var map = {
	"./a.mp3": 9700,
	"./acorde1-diminutos.mp3": 8539,
	"./acorde2-diminutos.mp3": 6896,
	"./acorde3-maior.mp3": 8907,
	"./af.mp3": 6858,
	"./b.mp3": 4139,
	"./bf.mp3": 6951,
	"./c.mp3": 1110,
	"./click1.mp3": 7742,
	"./click2.mp3": 3681,
	"./correctSound.mp3": 3032,
	"./d.mp3": 2381,
	"./df.mp3": 241,
	"./e.mp3": 1304,
	"./ef.mp3": 8286,
	"./f.mp3": 2447,
	"./g.mp3": 9482,
	"./gf.mp3": 9304,
	"./wrongSound.mp3": 2195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8285;